import { Bell, Building2, Handshake, Landmark, LayoutGrid, Printer, Server, type LucideIcon } from 'lucide-react'
import type { NotificationCategory, NotificationLevel } from './types'

export const CATEGORY_ICON: Record<NotificationCategory, LucideIcon> = { crm: Handshake, finance: Landmark, project: LayoutGrid, infra: Server, hr: Building2, printer: Printer, system: Bell }

export const LEVEL_TONE: Record<NotificationLevel, string> = {
  info: 'bg-info/12 text-info',
  success: 'bg-success/12 text-success',
  warning: 'bg-warning/15 text-warning-strong',
  critical: 'bg-destructive/12 text-destructive',
}
